import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createStore } from 'javascripts/store';
import { setUserFromJson, setCompanyFromJson } from 'actions';

const ReduxProvider = ({ children }: { children: React.ReactNode }) => {
  const { store, persistor } = createStore(() => {
    const { current_user_json } = window.gon;
    if (current_user_json) {
      store.dispatch(setUserFromJson());
      store.dispatch(setCompanyFromJson());
    }
  });

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>{children}</PersistGate>
    </Provider>
  );
};

export default ReduxProvider;
